import ControlerIcon from './component'

export default ControlerIcon
